import axios from 'axios';
import { clone } from 'lodash';

export const ACTIONS = {};
export const MUTATIONS = {};

export default {
    name: 'api',
    namespaced: true,
    state: {
        options: {
            baseURL: `${window.location.protocol}//${window.location.host}/api/`,
            // timeout: 10000, // 10 seconds
            headers: {},
            withCredentials: true,
        },
    },
    getters: {
        api(state, getters) {
            var apiOptions = clone(state.options);
            return axios.create(apiOptions);
        },
    },
};



// WEBPACK FOOTER //
// ./shared/store/modules/api.js